export enum OrdersRouterStateKey {
  TEMPLATE = 'template',
  ORDER = 'order',
  FLEET = 'fleet',
  FLEET_ROUTE = 'fleetRoute',
  ROUTE_CONFIG = 'routeConfig',
}
